import {createSlice, PayloadAction} from '@reduxjs/toolkit';

export enum ThemeMode {
    SYSTEM = 'system',
    LIGHT = 'light',
    DARK = 'dark',
}

export interface PreferencesChange {
    themeMode: ThemeMode;
}

export interface PreferencesState extends PreferencesChange {
    updated: boolean;
}

export const initialState: PreferencesState = {
    updated: false,
    themeMode: ThemeMode.SYSTEM,
};

const preferencesSlice = createSlice({
    initialState,
    name: 'preferences',
    reducers: {
        updatePreferences: (state: PreferencesState, action: PayloadAction<PreferencesChange>) => {
            state.updated = true
            state.themeMode = action.payload.themeMode
        },
        changeTheme: (state: PreferencesState, action: PayloadAction<ThemeMode>) => {
            state.themeMode = action.payload
        },
    },
});

export const {
    updatePreferences,
    changeTheme,
} = preferencesSlice.actions;

export default preferencesSlice
